import { palette, shape, typography } from '@src/core/styles';
import styled from 'styled-components';

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 768px;
`;

export const WrapContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 768px;

  & h1 {
    margin-bottom: 24px;
  }
`;

export const Subtitle = styled.div`
  ${typography.display_medium};
`;

export const Group = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
`;

export const Advantage = styled.div`
  border-radius: ${shape.rounding.L};
  padding: 12px 24px 12px 16px;
  border: 1px solid ${palette.colors.outline_variant};
  display: flex;
`;

export const Iconwrapper = styled.div`
  margin-right: 16px;
  width: 14px;
  height: 12px;

  & svg {
    width: 14px;
  }
`;

export const AdvantageTitle = styled.div`
  ${typography.body_large_regular};
`;

export const AdvantageText = styled.div`
  ${typography.body_medium_regular};
  color: ${palette.colors.onsurface_variant};
`;
